import { CircularProgress, Grid } from "@mui/material";
import type { ReactNode } from "react";

function LoadingPage(): ReactNode {
  return (
    <Grid container size={12} sx={{ justifyContent: "center", flexGrow: 1 }}>
      <CircularProgress size="15vh" sx={{ marginY: "20vh" }} />
    </Grid>
  );
}

export default LoadingPage;
